export default function (disableTouch) {
  if (!CLIENT) {
    return;
  }

  const htmlEl = document.documentElement;
  htmlEl.classList.toggle("noTouchAction", disableTouch);
}
